/**
 * Information-only variable that has all country values listed
 * They are grabbed from region.json
 */
export const allCountries = [
  'AD-AD',
  'ARG-A',
  'AT-AT',
  'AU-AU', // Australia
  'BA',
  'BE',
  'BG',
  'CAN',
  'CH-CH',
  'CL-CL',
  'CY',
  'CZ',
  'DE',
  'ES',
  'FI',
  'FR-FR',
  'GE',
  'GR',
  'HOL',
  'IS',
  'IT',
  'LI',
  'MK',
  'NO',
  'NZ-NZ',
  'PL',
  'PT',
  'RO',
  'RU',
  'SCT',
  'SE',
  'SI',
  'SK',
  'SRB',
  'USA',
  'europe',
  null,
];

export const isUSACanada = (country?: string) => !!(country && [
  'USA',
  'CAN',
].includes(country));

export const isDACHRegion = (country?: string) => !!(country && [
  'DE',
  'CH-CH',
  'AT-AT',
].includes(country));

export const regionShowAmountInSummary = (country?: string) => !!(country && [
  // ELocale.EN_US, ELocale.FR_FR, ELocale.SV_SE, ELocale.NN_NO, ELocale.EN_GB
  'USA',
  'NO',
  'SE',
].includes(country));

export const regionShowKmFallbackToAmountInSummary = (country?: string) => !!(country && ![
  // ELocale.EN_US, ELocale.FR_FR, ELocale.SV_SE, ELocale.NN_NO, ELocale.EN_GB
  'USA',
  'NO',
  'SE',
].includes(country));

export const regionShowAmountOnTerrain = (country?: string) => !!(country && [
  // ELocale.EN_US, ELocale.FR_FR, ELocale.SV_SE, ELocale.NN_NO, ELocale.EN_GB
  'NO',
  'SE',
  'FR',
  'UK', // TODO: No UK in country codes
].includes(country));

export const regionShowKmOnTerrain = (country?: string) => !!(isDACHRegion(country) || (country && [
  // IT, PL, SK, CZ, ES, DK, NL
  'IT',
  'PL',
  'SK',
  'ES',
  'DK', // TODO: missing
  'NL', // TODO: missing
].includes(country)));

export const isSouthernHemisphereCountry = (country?: string) => !!(country && [
  'USA',
  'CAN',
  'AU-AU',
  'ARG-A',
  'NZ-NZ',
  'CL-CL',
].includes(country));
